// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"ne","contentFrame":"nf","buttonGroup":"nh","button":"ni","header":"nj","text":"nk","contentImage":"nl","closeButton":"nm"};